import { MdLockOutline } from 'react-icons/md';
import { Tab, Tabs } from '@ds';
import { isCSDeductionRulesMode } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/period.utils';
import { useCSSettingsSelectedDay } from './hooks';
import {
  CSSchedulerSettingsAtHubInputsTab,
  CSSchedulerSettingsDeductionRulesTab,
  CSSchedulerSettingsInputsTab,
  CSSchedulerSettingsPeriodRulesTab,
  CSSchedulerSettingsRulesTab,
  CSSchedulerSettingsTimeGroupInputsTab,
} from './components';

const iconTabTitle = (title: string) => (
  <div className="flex items-center gap-1">
    <MdLockOutline size={16} />
    {title}
  </div>
);

const tabsClassNames = {
  tabContent: 'text-m-cps px-6',
  tabList: 'p-0',
  panel: 'h-full p-0',
};

/**
 * Which settings family is editable follows the period the user came from, not today's date:
 * a schedule before the deduction-rules cutover is planned from the monthly settings however
 * long its period is, so those are the settings that govern it.
 */
export const SchedulerClinicalSpecialistsSettings = () => {
  const selectedDay = useCSSettingsSelectedDay();
  const usesDeductionRules = isCSDeductionRulesMode(selectedDay);

  return (
    <div className="flex flex-col gap-4">
      {usesDeductionRules ? (
        <Tabs aria-label="Tabs" variant="underlined" classNames={tabsClassNames}>
          <Tab key="time-group-inputs" title="Inputs">
            <CSSchedulerSettingsTimeGroupInputsTab />
          </Tab>
          <Tab key="at-hub-inputs" title="At Hub Weekly requirements">
            <CSSchedulerSettingsAtHubInputsTab />
          </Tab>
          <Tab key="period-rules" title={iconTabTitle('Rules')}>
            <CSSchedulerSettingsPeriodRulesTab />
          </Tab>
          <Tab key="deduction-rules" title={iconTabTitle('Deduction Rules')}>
            <CSSchedulerSettingsDeductionRulesTab />
          </Tab>
        </Tabs>
      ) : (
        <Tabs aria-label="Tabs" variant="underlined" classNames={tabsClassNames}>
          <Tab key="inputs" title="Inputs">
            <CSSchedulerSettingsInputsTab />
          </Tab>
          <Tab key="rules" title={iconTabTitle('Rules')}>
            <CSSchedulerSettingsRulesTab />
          </Tab>
        </Tabs>
      )}
    </div>
  );
};
